import React from "react";
import PropTypes from "prop-types";
import { TvDiv } from "@trustvid/design-system";
import { LOGIN_PAGE_TESTIMONIAL } from "./loginPageContent";

const LoginFeatureTestimonial = ({ compact = false }) => (
  <TvDiv
    className={`tv-login-page__testimonial${compact ? " tv-login-page__testimonial--compact" : ""}`}
  >
    <TvDiv className="tv-login-page__testimonial-quote">
      &ldquo;{LOGIN_PAGE_TESTIMONIAL.quote}&rdquo;
    </TvDiv>
    <TvDiv className="tv-login-page__testimonial-author d-flex align-items-center gap-2">
      <TvDiv className="tv-login-page__testimonial-avatar d-flex align-items-center justify-content-center flex-shrink-0">
        {LOGIN_PAGE_TESTIMONIAL.initials}
      </TvDiv>
      <TvDiv>
        <TvDiv className="tv-login-page__testimonial-name">{LOGIN_PAGE_TESTIMONIAL.author}</TvDiv>
        <TvDiv className="tv-login-page__testimonial-role">{LOGIN_PAGE_TESTIMONIAL.role}</TvDiv>
      </TvDiv>
    </TvDiv>
  </TvDiv>
);

LoginFeatureTestimonial.propTypes = {
  compact: PropTypes.bool,
};

export default LoginFeatureTestimonial;
